"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiAccountsClient = void 0;
const ApiSubClient_1 = require("../../common/client/ApiSubClient");
const expandUrlTemplate_1 = __importDefault(require("../../common/utils/expandUrlTemplate"));
const AccountConverter_1 = require("../AccountConverter");
const AccountUserConverter_1 = require("../AccountUserConverter");
class ApiAccountsClient extends ApiSubClient_1.ApiSubClient {
    async getAccountApiClient(id) {
        const link = this.getLinkOrThrow('getAccountApiClient');
        const response = await this.axios.get((0, expandUrlTemplate_1.default)(link.href, { id }));
        return AccountConverter_1.AccountConverter.fromAccountApiClientEntity(response.data);
    }
    async getAccounts(request) {
        const link = this.getLinkOrThrow('getAccounts');
        return this.axios
            .get((0, expandUrlTemplate_1.default)(link.href, { ...request }))
            .then((response) => {
            return AccountConverter_1.AccountConverter.fromPageableAccountsEntity(response.data);
        });
    }
    async getAccount(id) {
        const link = this.getLinkOrThrow('getAccount');
        return this.axios
            .get((0, expandUrlTemplate_1.default)(link.href, { id }))
            .then((response) => {
            return AccountConverter_1.AccountConverter.fromAccountEntity(response.data);
        });
    }
    async createAccount(accountRequest) {
        const link = this.getLinkOrThrow('createAccount');
        return this.axios
            .post(link.href, accountRequest)
            .then((response) => {
            return AccountConverter_1.AccountConverter.fromAccountEntity(response.data);
        });
    }
    async deleteAccount(id) {
        const link = this.getLinkOrThrow('deleteAccount');
        await this.axios
            .delete((0, expandUrlTemplate_1.default)(link.href, { id }))
            .then((response) => {
            return response;
        });
    }
    async updateAccount(id, updateRequest) {
        const link = this.getLinkOrThrow('updateAccounts');
        return this.axios
            .patch((0, expandUrlTemplate_1.default)(link.href, { id }), updateRequest, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
            },
        })
            .then((response) => {
            return AccountConverter_1.AccountConverter.fromAccountEntity(response.data);
        });
    }
    async getAccountUsers(request) {
        const link = this.getLinkOrThrow('accountUsers');
        const { id, emailQuery, page, size } = request;
        return this.axios
            .get((0, expandUrlTemplate_1.default)(link.href, { id, query: emailQuery, page, size }))
            .then((response) => {
            return AccountUserConverter_1.AccountUserConverter.fromPageableAccountUsersEntity(response.data);
        });
    }
    async getAccountBulkUsers(id, request) {
        const link = this.getLinkOrThrow('accountBulkUsers');
        return this.axios
            .post((0, expandUrlTemplate_1.default)(link.href, { id }), request)
            .then((response) => {
            return response.data._embedded.users.map((entity) => {
                return AccountUserConverter_1.AccountUserConverter.fromAccountUserProfileEntity(entity);
            });
        });
    }
    async getAccountContentPackages(id) {
        const link = this.getLinkOrThrow('accountContentPackages');
        return this.axios
            .get((0, expandUrlTemplate_1.default)(link.href, { id }))
            .then((response) => {
            return response.data._embedded.accountContentPackages;
        });
    }
    async updateAccountContentPackages(id, updateRequest) {
        const link = this.getLinkOrThrow('updateAccountContentPackages');
        return this.axios.patch((0, expandUrlTemplate_1.default)(link.href, { id }), updateRequest);
    }
    async getAccountPrices(id) {
        const link = this.getLinkOrThrow('prices');
        const response = await this.axios.get((0, expandUrlTemplate_1.default)(link.href, { id }));
        return AccountConverter_1.AccountConverter.fromAccountPricesEntity(response.data);
    }
    async getSimilarAccounts(id) {
        const link = this.getLinkOrThrow('getSimilarAccounts');
        const response = await this.axios.get((0, expandUrlTemplate_1.default)(link.href, { id }));
        return AccountConverter_1.AccountConverter.fromAccountsEntity(response.data._embedded.accounts);
    }
    updateUserAccount(user, updateRequest) {
        const link = user.links?.updateUserAccount;
        if (!link) {
            throw Error('Not authorized to update account!');
        }
        return this.axios
            .patch((0, expandUrlTemplate_1.default)(link.getOriginalLink(), {}), updateRequest, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
            },
        })
            .then((response) => {
            return AccountConverter_1.AccountConverter.fromAccountEntity(response.data);
        });
    }
}
exports.ApiAccountsClient = ApiAccountsClient;
//# sourceMappingURL=ApiAccountsClient.js.map